import { Module } from 'wrapper6'

const $ = jQuery

export default class HedgePlant extends Module {
  ready (app) {
    $(document).on('change', 'input[name="hedge-plant"]', function () {
      const CONTENT = $(this).parent('label').parent('.buttons').parent('.hedge-plant__topbar').parent('.hedge-plant__inner').find('.hedge-plant__content')
      if ($(this).val() === 'true') {
        CONTENT.addClass('show')
      } else {
        CONTENT.removeClass('show')
      }
    })
  }
}
